// Import general mixin for shared functionality.
import mixin from './mixin';

const drugsOverviewApp = {
    mixins: [mixin],
    data() {
        return {
            dataJson: null,
            searchText: '',
            filter: '',
            isExpanded: false,
        }
    },
    computed: {
        filteredItems() {
            if (!this.dataJson) return [];
            let items = [...this.dataJson];

            if (this.filter) {
                items = items.filter(item =>
                    item.Name &&
                    Array.from(item.Name)[0].toUpperCase() === this.filter.toUpperCase()
                );
            }

            if (!this.searchText) return items;

            const searchLower = this.searchText.toLowerCase();
            items = items.filter(item => {
                return (
                    (item.Name && item.Name.toLowerCase().includes(searchLower)) ||
                    (item.Synoniemen.length && item.Synoniemen.some(s => s.toLowerCase().includes(searchLower))) ||
                    (item.Snippet && item.Snippet.toLowerCase().includes(searchLower))
                );
            });

            return items.sort((a, b) => a.Name.localeCompare(b.Name));
        },
        firstCharacters() {
            if (!this.dataJson) return [];
            return Array.from(new Set(this.dataJson.map(item => Array.from(item.Name)[0]))).sort();
        }
    },
    methods: {
        firstChar(currItem) {
            if (!currItem || !currItem.Name) return null;
            let index = this.filteredItems.findIndex(item => item.Id === currItem.Id);
            let prevItem = this.filteredItems[index - 1];
            if (!prevItem || (prevItem.Name && Array.from(prevItem.Name)[0] !== Array.from(currItem.Name)[0])) {
                return Array.from(currItem.Name)[0];
            } else {
                return null;
            }
        },
        setFilter(character) {
            this.filter = this.filter === character ? '' : character;
            const url = new URL(location);
            url.searchParams.set('filter', this.filter)
            if (!this.filter) url.searchParams.delete('filter');
            history.pushState({}, '', url);
        },
        clearSearchText() {
            this.searchText = '';
            const url = new URL(location);
            url.searchParams.delete('q');
            history.pushState({}, '', url);
        }
    },
    created() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.has('q')) this.searchText = urlParams.get('q');
        if (urlParams.has('filter')) this.filter = urlParams.get('filter');

        this.changeSearchText = this.debounce(event => {
            const url = new URL(location);
            url.searchParams.set('q', this.searchText);
            if (!this.searchText) url.searchParams.delete('q');
            history.pushState({}, '', url);
        });
    },
    mounted() {
        if (this.$el.dataset.json) this.dataJson = JSON.parse(this.$el.dataset.json);
    },
};

export default drugsOverviewApp;
